import React, { useMemo } from 'react';

import { Skeleton } from '@mui/material';

import LessonCard from '../../../components/LessonCard';
import { useGetStudentDetailsByLessonQuery } from '../../../services/classes';
import { Lesson } from '../../../services/classes/types';
import { useGetCoursesQuery } from '../../../services/courses';
import { useGetStaffQuery } from '../../../services/staff';
import { StudentState } from '../../../types/common';
import { getLessonClass, getLessonSubject } from '../../../utils/common/classes';

interface RollLessonCardProps {
  lesson: Lesson;
  selected: boolean;
  rollUnmarked?: boolean;
  onSelect: (lesson: Lesson) => void;
}

const RollLessonCard = ({
  lesson,
  selected,
  rollUnmarked = false,
  onSelect = () => {},
}: RollLessonCardProps) => {
  const { data: courses, isLoading: isCoursesLoading } = useGetCoursesQuery({});
  const { data: teacher, isLoading: isTeacherLoading } = useGetStaffQuery({
    staffId: lesson.teacher,
  }, { skip: !lesson.teacher });
  const { data: studentStates, isLoading: isStudentDetailsLoading } =
  useGetStudentDetailsByLessonQuery({
    subject: getLessonSubject(lesson), classId: getLessonClass(lesson), lesson: lesson.lesson, attribute: 'state',
  });

  // Count how many studentStates are PENDING_ATTENDANCE
  const pendingAttendanceCount = useMemo(() => studentStates?.data.filter((state) =>
    state === StudentState.PendingAttendance).length || 0, [studentStates]);

  if (isCoursesLoading || isTeacherLoading || isStudentDetailsLoading || !courses) {
    return (
      <Skeleton height={160} variant="rectangular" />
    );
  }

  return (
    <LessonCard
      teacher={teacher?.data}
      courses={courses.data}
      lesson={lesson}
      selected={selected}
      onSelect={() => onSelect(lesson)}
      showFullDate={rollUnmarked}
      hideClassName={rollUnmarked}
      newCount={pendingAttendanceCount}
    />
  );
};

export default RollLessonCard;
